import React, { Fragment, useEffect, useState } from "react";
import { Col, Modal, Nav, Row, Tab } from "react-bootstrap";
import {
  Playerfulldetails,
  playerotherachievementlist,
  Playerprofiledetails,
  Playerprofileupdate,
} from "../../../services/player";
import {
  classlist,
  schoollistmaster,
  sportslist,
  sportwisetypeparameterlist,
} from "../../../services/master";
import moment from "moment";
import { toast } from "react-toastify";
import dotracking from "../../trackinglogs";
import trackobj from "../../trackingpages.json";
import { useNavigate } from "react-router-dom";
import { AgGridReact } from "ag-grid-react";
import { Bar, Line, Radar } from "react-chartjs-2";
import {
  assessmentgraphsports,
  eventsmasterlist,
  viewpersonaltimingapi,
} from "../../../services/superadmin";
import { profileyeargraph } from "../../../services/common";
import Select from "react-select";

export const PlayerProfile = () => {
  const [fname, setFName] = useState("");
  const [lname, setLName] = useState("");
  const [school, setSchool] = useState("");
  const [slist, setSList] = useState([]);
  const [faname, setFaName] = useState("");

  const [sclist, setClassList] = useState([]);
  const [stuclass, setStuClass] = useState("");
  const [stusec, setStuSec] = useState("");
  const [dob, setDOB] = useState("");
  const [gender, setGender] = useState("");
  const [email, setEmail] = useState("");
  const [mobno, setMobNo] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [curdate, setCurDate] = useState("");

  const [splist, setSportList] = useState([]);
  const [stusport, setStuSport] = useState("");
  const [stupos, setStuPos] = useState("");

  const [stufq, setStuFQ] = useState("");
  const [stunfq, setStuNFQ] = useState("0.73");

  const [errorMsg, setErrorMsg] = useState("");

  const [pdetail, setPDetail] = useState("");

  const [page, setPAge] = useState("");
  const [pemer, setPEmer] = useState("");
  const [bgroup, setBGroup] = useState("");
  const [paddr, setPAddr] = useState("");
  const [pesid, setPESID] = useState("");
  const [pcoach, setPCoach] = useState("");
  const [ppastcoach, setPPastCoach] = useState("");

  const [hlist, setHList] = useState([]);
  const [filterProduct, setFilterProduct] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState("");
  const [gdata, setGData] = useState(null);
  const [opts, setOptn] = useState("");
  const [ptdet, setPtDet] = useState([]);
  const currentYear = new Date().getFullYear();
  const [tyear, setTYear] = useState(currentYear);
  const lastYear = currentYear - 1;

  const columnPDefs = [
    {
      headerName: "Tournament",
      field: "meet_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Level",
      field: "level",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Tournament Date",
      field: "start_date",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        if (params.value !== null) {
          return moment(params.value).format("DD-MM-yyyy");
        }
      },
    },
    {
      headerName: "Sports",
      field: "sports_type",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Event",
      field: "event",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Age Group",
      field: "category_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },

    {
      headerName: "Position",
      field: "position",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
  ];

  useEffect(() => {
    var a = new Date().getFullYear() - 7;
    var d = new Date(a, 11, 31);
    setCurDate(moment(d).format("YYYY-MM-DD"));

    classlist().then((response) => {
      if (response.status === true) {
        setClassList(response.data);
      }
    });

    sportslist().then((response) => {
      if (response.status === true) {
        setSportList(response.data);
      }
    });

    schoollistmaster().then((response) => {
      if (response.status === true) {
        setSList(response.data.details);
      }
    });

    viewlist(currentYear);
  }, []);

  function viewlist(lyear) {
    Playerprofiledetails(localStorage.getItem("Name")).then((response) => {
      if (response.status === true) {
        if (response.data.athletelist !== null) {
          setFName(response.data.athletelist.first_name);
          setFaName(response.data.athletelist.father_name);
          setLName(response.data.athletelist.last_name);
          setDOB(response.data.athletelist.date_of_birth);
          setStuClass(response.data.athletelist.class);
          setSchool(response.data.athletelist.school_id);
          setStuSec(response.data.athletelist.section);
          setGender(response.data.athletelist.gender);
          setEmail(response.data.athletelist.email_id);
          setMobNo(response.data.athletelist.mobile_no);
          if (response.data.athletelist.photograph !== null) {
            setPhotoUrl(
              response.data.photo_path + response.data.athletelist.photograph
            );
          }
          if (response.data.athletelist.sportsposition !== null) {
            setStuPos(response.data.athletelist.sportsposition);
          }

          if (response.data.athletelist.sports_typeid !== 0) {
            setStuSport(response.data.athletelist.sports_typeid);
          }
          if (response.data.athletelist.fq !== null) {
            setStuFQ(response.data.athletelist.fq);
          }

          setStuNFQ(response.data.athletelist.fq_bench_mark);

          if (response.data.athletelist.age !== null) {
            setPAge(response.data.athletelist.age);
          }
          if (response.data.athletelist.emergency_contact_no !== null) {
            setPEmer(response.data.athletelist.emergency_contact_no);
          }
          if (response.data.athletelist.blood_group !== null) {
            setBGroup(response.data.athletelist.blood_group);
          }
          if (response.data.athletelist.permenant_address_one !== null) {
            setPAddr(response.data.athletelist.permenant_address_one);
          }
          if (response.data.athletelist.ESID !== null) {
            setPESID(response.data.athletelist.ESID);
          }
          if (response.data.athletelist.current_coach_name !== null) {
            setPCoach(response.data.athletelist.current_coach_name);
          }
          if (response.data.athletelist.past_coach_or_mentor !== null) {
            setPPastCoach(response.data.athletelist.past_coach_or_mentor);
          }
          // setAttDet(response.data.attendace_report);
          // setPhDet(response.data.physical_health_data);
          // setPbDet(response.data.phychological_behavioral);
          // setUPath(response.data.player_files_path);
          // setACList(response.data.athlete_contract_files);
          // setCList(response.data.certificate_files);
          // setMCList(response.data.media_coverage_files);
          // setPList(response.data.photos_files);
          // setVList(response.data.videos_files);
          // setOFList(response.data.other_files_files);
        }
      }
    });
    Playerfulldetails(localStorage.getItem("UID"), lyear).then((response) => {
      if (response.status === true) {
        setPDetail(response.data.playerlist);
          setUPath(response.data.player_files_path);

         setACList(response.data.athlete_contract_files);
          setCList(response.data.certificate_files);
          setMCList(response.data.media_coverage_files);
          setPList(response.data.photos_files);
          setVList(response.data.videos_files);
          setOFList(response.data.other_files_files);
        setHList(response.data.highest_level_achievements);
        setAttDet(response.data.attendace_report);
        if (response.data.physical_health_data.length != 0) {
          const formattedData = response.data.physical_health_data.map(
            (item) => ({
              ...item,
              record_date:
                item.record_date !== null
                  ? moment(item.record_date).format("DD-MM-YYYY")
                  : "",
            })
          );
          setPhDet(formattedData);
        }
        setPbDet(response.data.phychological_behavioral);
        if (response.data.personal_timings.length != 0) {
          const formattedData = response.data.personal_timings.map((item) => ({
            ...item,
            record_date:
              item.record_date !== null
                ? moment(item.record_date).format("DD-MM-YYYY")
                : "",
          }));
          setPtDet(formattedData);
        }

         if (response.data.attendance_graph.length != 0) {
            const years = response.data.attendance_graph.map((item) => {
              const attendancePercentage = parseFloat(
                item.attendance_percentage
              );

              if (isNaN(attendancePercentage)) {
                return item.month_name + " (0%)";
              }

              const formattedPercentage =
                attendancePercentage % 1 === 0
                  ? attendancePercentage.toFixed(0)
                  : attendancePercentage.toFixed(2);

              return item.month_name + " (" + formattedPercentage + "%)";
            });
            const maleCounts = response.data.attendance_graph.map(
              (item) => item.total_present
            );
            const femaleCounts = response.data.attendance_graph.map(
              (item) => item.total_sessions_conducted
            );
            const pdata = {
              labels: years,
              datasets: [
                {
                  label: "Present",
                  data: maleCounts,
                  backgroundColor: "#25e3da",
                },
                {
                  label: "Session Conducted",
                  data: femaleCounts,
                  backgroundColor: "#f74dc1",
                },
              ],
            };
            setGAttDet(pdata);
          }

        profileyeargraph(
          response.data.playerlist.school_id,
          localStorage.getItem("UID")
        ).then((res) => {
          if (res.status === true) {
            const data = res.data;
            const years = data.year_array.map((item) => item.year);
            const medalField = selectedFilter
              ? `${selectedFilter}_Medals`
              : "medals_count";
            const participationField = selectedFilter
              ? `${selectedFilter}_Participation`
              : "participation_count";

            const medalData = data.year_array.map(
              (item) => item[medalField] || 0
            );

            const participationData = data.year_array.map(
              (item) => item[participationField] || 0 // If no selectedFilter, use Participation_count
            );

            const pdata = {
              labels: years,
              datasets: [
                {
                  label: `${selectedFilter} Medals`,
                  data: medalData,
                  backgroundColor: "#0000FF", // Color for medals
                },
                {
                  label: `${selectedFilter} Participation`,
                  data: participationData,
                  backgroundColor: "#FE019A", // Color for participation
                },
              ],
            };

            setGData(pdata);

            if (window.innerWidth < 768) {
              const odata = {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                  legend: {
                    position: "top",
                  },
                  title: {
                    display: true,
                    //   text: 'ABC',
                  },
                },
                scales: {
                  x: {
                    title: {
                      display: true,
                      text: "",
                    },
                  },
                  y: {
                    title: {
                      display: true,
                      text: "",
                    },
                  },
                },
              };
              setOptn(odata);
            } else {
              const odata = {
                responsive: true,
                maintainAspectRatio: true,
                plugins: {
                  legend: {
                    position: "top",
                  },
                  title: {
                    display: true,
                    //   text: 'ABC',
                  },
                },
                scales: {
                  x: {
                    title: {
                      display: true,
                      text: "",
                    },
                  },
                  y: {
                    title: {
                      display: true,
                      text: "",
                    },
                  },
                },
              };
              setOptn(odata);
            }
          }
        });
      }
    });
    playerotherachievementlist(localStorage.getItem("UID")).then((response) => {
      if (response.status === true) {
        let arr = [];
        let arr1 = [];
        if (response.data.length !== 0) {
          if (response.data.our_achievements.length !== 0) {
            arr = response.data.our_achievements;
          }
          if (response.data.other_achivements.length !== 0) {
            arr1 = response.data.other_achivements;
          }
          let arr2 = arr.concat(arr1);
          setFilterProduct(arr2);
        }
      }
    });
  }

  function handleEvent(e) {
    setPTData("");
    if (e != null) {
      setPEvent(e);
      loadperson(ptsport, e, stype);
    } else {
      setPEvent("");
      loadperson(ptsport, 0, stype);
    }
  }

  const [ptsport, setPTSport] = useState("");
  const [pevent, setPEvent] = useState(0);
  const [pelist, setPEList] = useState([]);
  const [sname, setSName] = useState("");
  const [stype, setSType] = useState("");
  const [elist, setEList] = useState([]);
  function personalsport(e, ptype) {
    setPTSport(e.target.value);
    setSName("");
    setPEvent("");
    setPEList([]);
    setSType(ptype);
    setPTData("");
    let arr = [];
    if (e.target.value !== null) {
      const data = splist.find((item) => item.sports_cat_uid == e.target.value);
      setSName(data.sports_category);

      eventsmasterlist().then((response) => {
        if (response.status === true) {
          if (response.data.length !== 0) {
            setEList(response.data);
            for (let i = 0; i < response.data.length; i++) {
              if (response.data[i].is_active === 1) {
                arr.push({
                  value: response.data[i].event_uid,
                  label: response.data[i].event_name,
                });
              }
            }
          }
          setPEList(arr);
        }
      });

      loadperson(e.target.value, 0, stype);
    }
  }
  function convertToMinutes(timeString) {
    const parts = timeString.split(":");

    let hours = 0,
      minutes = 0,
      seconds = 0,
      milliseconds = 0;

    if (parts.length === 3) {
      // Format: hh:mm:ss.sss
      hours = parseInt(parts[0], 10);
      minutes = parseInt(parts[1], 10);

      const secParts = parts[2].split(".");
      seconds = parseInt(secParts[0], 10);
      milliseconds = secParts[1] ? parseInt(secParts[1].padEnd(3, "0"), 10) : 0;
    } else {
      return 0;
    }

    const totalSeconds =
      hours * 3600 + minutes * 60 + seconds + milliseconds / 1000;
    return totalSeconds / 60;
  }
  const [copts, setCOpts] = useState({});

  const [ptdata, setPTData] = useState("");

  function loadperson(sp, ev, tpe) {
    setSType(tpe);
    setPTData("");
    const etype = elist.find(
      (item) => item.event_uid === (ev != 0 ? ev.value : 0)
    );
    const eventTypeName = etype ? etype.event_type_name : null;
    const temp = new FormData();
    temp.append("sports_id", sp);
    temp.append("event_id", ev != 0 ? ev.value : 0);
    temp.append("user_id", localStorage.getItem("UID"));
    temp.append("competition_training", tpe);
    viewpersonaltimingapi(temp).then((res) => {
      if (res.status === true) {
        if (res.data && res.data.physical_assessment_record_date.length > 0) {
          let normValueInMinutes = 0;
          let timingData = [];
          let targetData = [];
          if (sname.toUpperCase() === "ATHLETICS" && eventTypeName == "Track") {
            normValueInMinutes =
              res.data.norm_value !== 0
                ? convertToMinutes(res.data.norm_value)
                : 0;

            timingData = res.data.physical_assessment_record_date.map((item) =>
              convertToMinutes(item.timing_timestamp)
            );

            targetData = res.data.physical_assessment_record_date.map((item) =>
              convertToMinutes(item.target)
            );
          } else {
            normValueInMinutes = res.data.norm_value;
            timingData = res.data.physical_assessment_record_date.map(
              (item) => {
                const raw = item.timing_timestamp;
                return parseFloat(raw.replace(/[^\d.]/g, ""));
              }
            );
            targetData = res.data.physical_assessment_record_date.map(
              (item) => item.target
            );
          }
          const originalTimingData =
            res.data.physical_assessment_record_date.map(
              (item) => item.timing_timestamp
            );
          const originalTargetData =
            res.data.physical_assessment_record_date.map((item) => item.target);
          const labels = res.data.physical_assessment_record_date.map(
            (item) => moment(item.record_date).format("DD-MM-YYYY") || "Date"
          );
          const normData = new Array(
            res.data.physical_assessment_record_date.length
          ).fill(normValueInMinutes);

          const pdata = {
            labels,
            datasets: [
              {
                label: "Norms",
                data: normData,
                borderColor: "grey",
                backgroundColor: "rgba(128, 128, 128, 0.2)",
                fill: false,
                borderWidth: 2,
                tension: 0.1,
              },
              {
                label: "Timing",
                data: timingData,
                borderColor: "blue",
                backgroundColor: "rgba(0, 0, 255, 0.2)",
                fill: false,
                borderWidth: 2,
                tension: 0.1,
              },
              {
                label: "Target",
                data: targetData,
                showLine: false,
                pointRadius: 5,
                pointHoverRadius: 7,
                pointBackgroundColor: "red",
                pointBorderColor: "darkred",
                borderColor: "red",
                backgroundColor: "#ef94a3",
                fill: false,
                // borderWidth: 2,
                // tension: 0.1,
                // borderDash: [5, 5],
              },
              // {
              //   label: "Target",
              //   data: targetData,
              //   showLine: false,              // hide the line
              //   pointStyle: targetImg,        // use image as point
              //   pointRadius: 10,              // size of the image
              //   pointHoverRadius: 12,
              //   backgroundColor: 'transparent', // no background color
              //   borderColor: 'transparent',     // no border
              // },
            ],
          };

          setPTData(pdata);

          const chartOptions = {
            responsive: true,
            plugins: {
              tooltip: {
                callbacks: {
                  label: function (context) {
                    const datasetLabel = context.dataset.label || "";
                    const index = context.dataIndex;

                    if (datasetLabel === "Timing") {
                      return `Timing: ${originalTimingData[index]}`;
                    } else if (datasetLabel === "Target") {
                      return `Target: ${originalTargetData[index]}`;
                    } else if (datasetLabel === "Norms") {
                      return `Norm: ${res.data.norm_value}`;
                    }

                    return `${datasetLabel}: ${context.parsed.y}`;
                  },
                },
              },
            },
            scales: {
              y: {
                title: {
                  display: true,
                  text:
                    sname.toUpperCase() === "ATHLETICS" &&
                    eventTypeName === "Track"
                      ? "Time (minutes)"
                      : "Distance (meters)",
                },
              },
              x: {
                title: {
                  display: false,
                  text: "Date",
                },
              },
            },
          };

          if (window.innerWidth < 768) {
            chartOptions.maintainAspectRatio = false;
          } else {
            chartOptions.maintainAspectRatio = true;
          }

          setCOpts(chartOptions);
        }
      }
    });
  }

  const getRandomColor = () => {
    const r = Math.floor(Math.random() * 255);
    const g = Math.floor(Math.random() * 255);
    const b = Math.floor(Math.random() * 255);
    return {
      backgroundColor: `rgba(${r}, ${g}, ${b}, 0.4)`,
      borderColor: `rgba(${r}, ${g}, ${b}, 1)`,
      pointBackgroundColor: `rgba(${r}, ${g}, ${b}, 1)`,
    };
  };
  const [asstype, setAssType] = useState("");
  const [tlist, setTList] = useState([]);
  const [usport, setUSport] = useState("");
  const [grdata, setGRData] = useState(null);
  const [ropts, setROptn] = useState("");
  const [glist, setGList] = useState([]);
  const [gattdet, setGAttDet] = useState("");
  const [aopts, setAOpts] = useState({});

  function loadsport(e) {
    setUSport(e.target.value);
    setAssType("");
    setTList([]);
    if (e.target.value !== null) {
      sportwisetypeparameterlist(e.target.value).then((response) => {
        if (response.status === true) {
          setTList(response.data.sportsParameters);
          if (response.data.sportsParameters.length == 0) {
            loadgraph(e.target.value, "");
          }
        }
      });
    }
  }
  const [paramList, setParamList] = useState([]);
  function loadgraph(sprt, e) {
    if (e !== null && e !== "") {
      setAssType(e.target.value);
    }
    const temp = new FormData();
    temp.append("sports_id", sprt);
    temp.append("user_id", localStorage.getItem("UID"));
    temp.append("assessment_type_id", e ? e.target.value : "");

    assessmentgraphsports(temp).then((res) => {
      if (res.status === true) {
        if (!res.data || !res.data.physical_assessment) {
          return { labels: [], datasets: [] }; // Handle invalid response
        }

        setGList(res.data.physical_assessment);
        const parameterInfo = res.data?.physical_assessment[0]?.assessments.map(
          (assessment) => ({
            name: assessment.parameter_name,
            desc: assessment.parameter_type_description,
          })
        );
        setParamList(parameterInfo);
        // Define the unique parameter names (Heats, Finals, Singles, Doubles)
        const axisLabels = res.data?.physical_assessment[0]?.assessments.map(
          (assessment) => assessment.parameter_name
        );

        // Generate the datasets for the radar chart
        const datasets = res.data.physical_assessment.map(
          (assessmentData, dateIndex) => {
            const date = assessmentData.record_date; // Current record_date

            const data = assessmentData.assessments.map((assessment) => {
              // Extract the parameter value (assuming it's a single value, not a comma-separated list)
              return parseFloat(assessment.parameter_value) || 0;
            });

            const color = getRandomColor(); // Get a random color for the dataset
            return {
              label: moment(date).format("DD-MM-YYYY"),
              data: data,
              backgroundColor: color.backgroundColor,
              borderColor: color.borderColor,
              pointBackgroundColor: color.pointBackgroundColor,
              borderWidth: 2,
              fill: false,
            };
          }
        );

        // Prepare the radar data structure
        const radarData = {
          labels: axisLabels, // Use parameter names as axis labels
          datasets: datasets,
        };

        setGRData(radarData);

        // Radar chart options
        const RadarOptions = {
          responsive: true,
          maintainAspectRatio: window.innerWidth >= 768,
          scales: {
            r: {
              angleLines: {
                display: true,
              },
              suggestedMin: 0,
              suggestedMax:
                Math.max(...datasets.flatMap((dataset) => dataset.data)) + 10,
            },
          },
          plugins: {
            tooltip: {
              callbacks: {
                title: () => "",
                label: function (tooltipItem) {
                  const datasetIndex = tooltipItem.datasetIndex;
                  const dataIndex = tooltipItem.dataIndex;
                  const assessmentData =
                    res.data.physical_assessment[datasetIndex]?.assessments[
                      dataIndex
                    ];

                  if (assessmentData) {
                    const value =
                      parseFloat(assessmentData.parameter_value) || 0;
                    return `${tooltipItem.label}: ${value}`;
                  }

                  return `${tooltipItem.label}: ''`;
                },
              },
            },
          },
        };

        setROptn(RadarOptions);
      }
    });
  }

  const [photoerror, setPhotoError] = useState("");
  const [photourl, setPhotoUrl] = useState("");
  const [photo, setPhoto] = useState("");

  function photofile(event) {
    setPhotoError("");
    setPhoto("");
    if (event.target.files.length !== 0) {
      if (event.target.files[0].name.match(/\.(jpg|jpeg|png)$/i)) {
        setPhotoUrl(URL.createObjectURL(event.target.files[0]));
        setPhoto(event.target.files[0]);
      } else {
        setPhotoError("Photograph should be jpg, jpeg, or png format");
      }
      var size = event.target.files[0].size / 1024 / 1024;
      if (size > 5) {
        setPhotoError("Photograph size should be less than 5MB");
      }
    }
  }

  function LetterOnly(eve) {
    if (/^[a-zA-Z\s]*$/.test(eve.key)) {
      return true;
    } else {
      eve.preventDefault();
      return false;
    }
  }

  function onPasteLetter(e) {
    const str = e.clipboardData.getData("Text");
    const newStr = str.replace(/[+-.]/g, "");
    if (str !== newStr) {
      e.preventDefault();
    }
  }

  const handleChange = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      setMobNo(e.target.value);
    }
  };

  function errorhandle(ev) {
    ev.target.src = require("../../../assets/images/users.png");
    ev.target.onerror = null;
  }
  const navigate = useNavigate();
  function perflist() {
    dotracking(
      "overall performance button in profile " +
        fname +
        +" (" +
        localStorage.getItem("UID") +
        ") $$ " +
        trackobj.overperfheading
    );
    navigate("/player/overallperformanceplayer");
  }

  function perftourlist() {
    dotracking(
      "tournament wise performance button in profile " +
        fname +
        +" (" +
        localStorage.getItem("UID") +
        ") $$ " +
        trackobj.tourperfheading
    );
    navigate("/player/viewperformanceplayer");
  }

  function subbmitprofile() {
    setErrorMsg("");
    setSubmitted(true);
    if (
      fname !== "" &&
      gender !== "" &&
      dob !== "" &&
      // mobno !== "" &&
      // email !== "" &&
      school !== "" &&
      stuclass !== "" &&
      stusec !== ""
    ) {
      const temp = new FormData();
      temp.append("user_id", localStorage.getItem("UID"));
      temp.append("first_name", fname);
      temp.append("date_of_birth", dob);
      temp.append("gender", gender);
      temp.append("email_id", email);
      temp.append("father_name", faname);
      temp.append("mobile_no", mobno);
      temp.append("school_id", school);
      temp.append("class", stuclass);
      temp.append("section", stusec);
      temp.append("photograph", photo);
      temp.append("position", stupos);
      temp.append("sports_pos_id", 0);
      temp.append("active_or_passive", 1);
      temp.append("date_of_join", "-");

      temp.append("sports_typeid", stusport);
      if (stusport !== "") {
        const sname = splist.find(
          (item) => item.sports_cat_uid === parseInt(stusport)
        );
        temp.append("sports", sname.sports_category);
      } else {
        temp.append("sports", "");
      }

      temp.append("fq", stufq);
      if (stunfq !== null) {
        temp.append("fq_bench_mark", stunfq);
      } else {
        temp.append("fq_bench_mark", "0.73");
      }
      dotracking(
        "update profile button in profile " +
          fname +
          +" (" +
          localStorage.getItem("UID") +
          ") $$ " +
          trackobj.profileheading
      );

      Playerprofileupdate(temp).then((response) => {
        if (response.status === true) {
          setSubmitted(false);
          localStorage.setItem("User", fname);
          viewlist();
          toast.success(response.message);
        } else {
          setErrorMsg(response.message);
        }
      });
    }
  }

  const [attdet, setAttDet] = useState([]);
  const [phdet, setPhDet] = useState([]);
  const [pbdet, setPbDet] = useState([]);

  const [aclist, setACList] = useState([]);
  const [clist, setCList] = useState([]);
  const [mclist, setMCList] = useState([]);
  const [plist, setPList] = useState([]);
  const [vlist, setVList] = useState([]);
  const [oflist, setOFList] = useState([]);
  const [upath, setUPath] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage] = useState(12);

  const totalRecordsToShow = currentPage * recordsPerPage;
  const currentRecords = aclist ? aclist.slice(0, totalRecordsToShow) : [];

  const loadMore = () => {
    setCurrentPage((prevPage) => prevPage + 1);
  };

  const [certcurrentPage, setCertCurrentPage] = useState(1);
  const certRecordsToShow = certcurrentPage * recordsPerPage;
  const certcurrentRecords = clist ? clist.slice(0, certRecordsToShow) : [];

  const certloadMore = () => {
    setCertCurrentPage((prevPage) => prevPage + 1);
  };

  const [mediacurrentPage, setMediaCurrentPage] = useState(1);
  const mediaRecordsToShow = mediacurrentPage * recordsPerPage;
  const mediacurrentRecords = mclist ? mclist.slice(0, mediaRecordsToShow) : [];

  const medialoadMore = () => {
    setMediaCurrentPage((prevPage) => prevPage + 1);
  };

  const [photocurrentPage, setPhotoCurrentPage] = useState(1);
  const photoRecordsToShow = photocurrentPage * recordsPerPage;
  const photocurrentRecords = plist ? plist.slice(0, photoRecordsToShow) : [];

  const photoloadMore = () => {
    setPhotoCurrentPage((prevPage) => prevPage + 1);
  };

  const [videocurrentPage, setVideoCurrentPage] = useState(1);
  const videoRecordsToShow = videocurrentPage * recordsPerPage;
  const videocurrentRecords = vlist ? vlist.slice(0, videoRecordsToShow) : [];

  const videoloadMore = () => {
    setVideoCurrentPage((prevPage) => prevPage + 1);
  };

  const [othercurrentPage, setOtherCurrentPage] = useState(1);
  const otherRecordsToShow = othercurrentPage * recordsPerPage;
  const othercurrentRecords = oflist ? oflist.slice(0, otherRecordsToShow) : [];

  const otherloadMore = () => {
    setOtherCurrentPage((prevPage) => prevPage + 1);
  };
  const [ushow, setUShow] = useState(false);
  const [udetail, setUDetail] = useState("");
  function udetshow(udet) {
    setUShow(true);
    setUDetail(udet);
  }

  function udetclose() {
    setUShow(false);
    setUDetail("");
  }

  const columnAtDefs = [
    {
      headerName: "Date",
      field: "attendance_date",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        if (params.value !== null) {
          return moment(params.value).format("DD-MM-yyyy");
        }
      },
    },
    {
      headerName: "Present / Absent",
      field: "present_or_absent",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
  ];

  const columnPtDefs = [
    {
      headerName: "Sports",
      field: "sports_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Event",
      field: "event_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Timing With Timestamp",
      field: "timing_timestamp",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
  ];

  const columnPhDefs = [
    {
      headerName: "Height",
      field: "height",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Weight",
      field: "weight",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Body Mass Index",
      field: "body_mass_index",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Past injuries",
      field: "past_injuries",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Diet Chart with Dietary Preferences/Restrictions",
      field: "diet_chart",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Known health conditions",
      field: "known_health",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
  ];

  return (
    <Fragment>
      <div className="side-app">
        <div className="page-header">
          <div className="breadcrumb">
            <h4 className="mb-0">Profile</h4>
          </div>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a>Profile</a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              My Profile
            </li>
          </ol>
        </div>

        <div className="row" id="user-profile">
          <div className="col-lg-12">
            <div className="card profilecard">
              <div className="card-body">
                <div className="wideget-user">
                  <div className="row">
                    <div className="col-lg-6 col-md-12 align-self-center">
                      <div className="wideget-user-desc d-flex">
                        <div className="wideget-user-img">
                          <img
                            src={photourl}
                            alt="img"
                            onError={(e) => errorhandle(e)}
                          />
                        </div>
                        <div className="user-wrap align-self-center">
                          <h3>{localStorage.getItem("User")}</h3>
                          <h3 className="mb-0 text-muted">
                            UID - {localStorage.getItem("Name")}
                          </h3>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-12 align-self-center">
                      <div className="wideget-user-info">
                        <div className="wideget-user-warap">
                          <div className="wideget-user-warap-l">
                            <h4 className="text-danger">0</h4>
                            <p className="mb-0">Tournaments</p>
                          </div>
                          <div className="wideget-user-warap-r">
                            <h4 className="text-danger">0</h4>
                            <p className="mb-0">Achievements</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card">
              <div className="card-header border-bottom">
                <h3 className="card-title font-weight-bold">Personal Detail</h3>
                {/* <div className="card-options">
                                    <button id="add__new__list" type="button" className="btn btn-md btn-info-gradient"><i className="fas fa-edit"></i> Edit Details</button>
                                </div> */}
              </div>
              <div className="card-body">
                <div className="border-0">
                  <div className="row tournamentitem">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label className="form-label">
                          First Name <span className="errortext"> *</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="First Name"
                          value={fname}
                          onChange={(e) => setFName(e.target.value)}
                          onKeyPress={LetterOnly}
                          onPaste={onPasteLetter}
                        />
                        {submitted && !fname && (
                          <span className="errortext">
                            First Name is required
                          </span>
                        )}
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label className="form-label">
                          Gender <span className="errortext"> *</span>
                        </label>
                        <select
                          value={gender}
                          className="form-control"
                          onChange={(e) => setGender(e.target.value)}
                        >
                          <option value="" defaultValue disabled>
                            --- Select Gender ---
                          </option>
                          <option value="Male">Male</option>
                          <option value="Female">Female</option>
                        </select>
                        {submitted && !gender && (
                          <span className="errortext">Gender is required</span>
                        )}
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label className="form-label">
                          Date of Birth <span className="errortext"> *</span>
                        </label>
                        <input
                          type="date"
                          className="form-control"
                          value={dob}
                          max={curdate}
                          onChange={(e) => setDOB(e.target.value)}
                          onKeyPress={(event) => {
                            event.preventDefault();
                          }}
                          onKeyDown={(event) => {
                            event.preventDefault();
                          }}
                        />
                        {submitted && !dob && (
                          <span className="errortext">
                            Date of Birth is required
                          </span>
                        )}
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label className="form-label">
                          Contact Number
                          {/* <span className="errortext"> *</span> */}
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Contact Number"
                          value={mobno}
                          onChange={handleChange}
                          maxLength={10}
                          onPaste={(e) => {
                            e.preventDefault();
                            return false;
                          }}
                          onCopy={(e) => {
                            e.preventDefault();
                            return false;
                          }}
                        />
                        {/* {submitted && !mobno && (
                          <span className="errortext">
                            Contact Number is required
                          </span>
                        )} */}
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label className="form-label">
                          Email Address
                          {/* <span className="errortext"> *</span> */}
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Email"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          onPaste={(e) => {
                            e.preventDefault();
                            return false;
                          }}
                          onCopy={(e) => {
                            e.preventDefault();
                            return false;
                          }}
                        />
                        {/* {submitted && !email && (
                          <span className="errortext">
                            Email Address is required
                          </span>
                        )} */}
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label className="form-label">Father Name</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Father Name"
                          value={faname}
                          onChange={(e) => setFaName(e.target.value)}
                          onKeyPress={LetterOnly}
                          onPaste={onPasteLetter}
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="details-group">
                        <div className="row">
                          <div className="col-md-4">
                            <b className="text-inverse">Registered Date</b>
                          </div>
                          <div className="col-md-8">
                            <span className="text-inverse">
                              {pdetail?.registerdate
                                ? moment(pdetail?.registerdate).format(
                                    "DD-MM-YYYY"
                                  )
                                : ""}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="details-group">
                        <div className="row">
                          <div className="col-md-4">
                            <b className="text-inverse">Active or Passive</b>
                          </div>
                          <div className="col-md-8">
                            <span className="text-inverse">
                              {pdetail?.active_or_passive == 1
                                ? "Active"
                                : "Passive"}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="details-group">
                        <div className="row">
                          <div className="col-md-4">
                            <b className="text-inverse">Date of Joining</b>
                          </div>
                          <div className="col-md-8">
                            <span className="text-inverse">
                              {pdetail?.date_of_join
                                ? moment(pdetail?.date_of_join).format(
                                    "DD-MM-YYYY"
                                  )
                                : ""}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="card">
              <div className="card-header border-bottom">
                <h3 className="card-title font-weight-bold">School Detail</h3>
                {/* <div className="card-options">
                                    <button id="add__new__list" type="button" className="btn btn-md btn-info-gradient"><i className="fas fa-edit"></i> Edit Details</button>
                                </div> */}
              </div>
              <div className="card-body">
                <div className="border-0">
                  <div className="row tournamentitem">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label className="form-label">
                          School <span className="errortext"> *</span>
                        </label>
                        <select
                          value={school}
                          className="form-control"
                          onChange={(e) => setSchool(e.target.value)}
                        >
                          <option value="" defaultValue disabled>
                            --- Select School ---
                          </option>
                          {slist.map((data, i) => {
                            return (
                              <option value={data.id} key={i}>
                                {data.school_name}
                              </option>
                            );
                          })}
                        </select>
                        {submitted && !school && (
                          <span className="errortext">School is required</span>
                        )}
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label className="form-label">
                          Class <span className="errortext"> *</span>
                        </label>
                        <select
                          value={stuclass}
                          className="form-control"
                          onChange={(e) => setStuClass(e.target.value)}
                        >
                          <option value="" defaultValue disabled>
                            --- Select Class ---
                          </option>
                          {sclist.map((data, i) => {
                            return (
                              <option value={data.id} key={i}>
                                {data.class}
                              </option>
                            );
                          })}
                        </select>
                        {submitted && !stuclass && (
                          <span className="errortext">Class is required</span>
                        )}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label className="form-label">
                          Section <span className="errortext"> *</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Section"
                          value={stusec}
                          onChange={(e) =>
                            setStuSec(e.target.value.toUpperCase())
                          }
                        />

                        {submitted && !stusec && (
                          <span className="errortext">Section is required</span>
                        )}
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="details-group">
                        <div className="row">
                          <div className="col-md-4">
                            <b className="text-inverse">CHID</b>
                          </div>
                          <div className="col-md-8">
                            <span className="text-inverse">-</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* <div className="col-md-6">
                                            <div className="form-group">
                                                <label className="form-label">City <span className='errortext'> *</span></label>
                                                <input type="text" className="form-control" placeholder="Enter Section" value={stusec}
                                                    onChange={(e) => setStuSec(e.target.value.toUpperCase())}
                                                />

                                                {submitted && !stusec &&
                                                    <span className='text-danger'>Section is required</span>
                                                }
                                            </div>
                                        </div> */}
                  </div>
                </div>
              </div>
            </div>

            {/* <div className="card">
              <div className="card-header border-bottom">
                <h3 className="card-title font-weight-bold">Other Detail</h3>
              </div>
              <div className="card-body">
                <div className="border-0">
                  <div className="row tournamentitem">
                    <div className="col-md-6">
                      <div className="details-group">
                        <div className="row">
                          <div className="col-md-4">
                            <b className="text-inverse">Age</b>
                          </div>
                          <div className="col-md-8">
                            <span className="text-inverse">{page}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="details-group">
                        <div className="row">
                          <div className="col-md-4">
                            <b className="text-inverse">Emergency Contact</b>
                          </div>
                          <div className="col-md-8">
                            <span className="text-inverse">{pemer}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="details-group">
                        <div className="row">
                          <div className="col-md-4">
                            <b className="text-inverse">Blood Group</b>
                          </div>
                          <div className="col-md-8">
                            <span className="text-inverse">{bgroup}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="details-group">
                        <div className="row">
                          <div className="col-md-4">
                            <b className="text-inverse">Address</b>
                          </div>
                          <div className="col-md-8">
                            <span className="text-inverse">{paddr}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="details-group">
                        <div className="row">
                          <div className="col-md-4">
                            <b className="text-inverse">ESID</b>
                          </div>
                          <div className="col-md-8">
                            <span className="text-inverse">{pesid}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="details-group">
                        <div className="row">
                          <div className="col-md-4">
                            <b className="text-inverse">Current Coach Name</b>
                          </div>
                          <div className="col-md-8">
                            <span className="text-inverse">{pcoach}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="details-group">
                        <div className="row">
                          <div className="col-md-4">
                            <b className="text-inverse">
                              Past Coaches/ Mentors
                            </b>
                          </div>
                          <div className="col-md-8">
                            <span className="text-inverse">{ppastcoach}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}

            {/* <div className="card">
              <div className="card-header border-bottom">
                <h3 className="card-title font-weight-bold">Sports Detail</h3>
               
              </div>
              <div className="card-body">
                <div className="border-0">
                  <div className="row tournamentitem">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label className="form-label">Sports </label>
                        <select
                          value={stusport}
                          className="form-control"
                          onChange={(e) => setStuSport(e.target.value)}
                        >
                          <option value="" defaultValue disabled>
                            --- Select Sports ---
                          </option>
                          {splist.map((data, i) => {
                            return (
                              <option value={data.sports_cat_uid} key={i}>
                                {data.sports_category}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label className="form-label">Position </label>

                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Your Position"
                          value={stupos}
                          onChange={(e) => setStuPos(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}

            <div className="card">
              <div className="card-header border-bottom">
                <h3 className="card-title font-weight-bold">Fitness Detail</h3>
                {/* <div className="card-options">
                                        <button id="add__new__list" type="button" className="btn btn-md btn-info-gradient"><i className="fas fa-edit"></i> Edit Details</button>
                                    </div> */}
              </div>
              <div className="card-body">
                <div className="border-0">
                  <div className="row tournamentitem">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label className="form-label">Your FQ </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Your FQ"
                          value={stufq}
                          onChange={(e) => setStuFQ(e.target.value)}
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label className="form-label">
                          {new Date().getFullYear()} National FQ Benchmark{" "}
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter National FQ Benchmark"
                          value={stunfq}
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card">
              <div className="card-header border-bottom">
                <h3 className="card-title font-weight-bold">Other Details</h3>
              </div>
              <div className="card-body">
                <div className="border-0">
                  <div className="row tournamentitem">
                    <div className="col-md-6">
                      <div className="details-group">
                        <div className="row">
                          <div className="col-md-4">
                            <b className="text-inverse">Age</b>
                          </div>
                          <div className="col-md-8">
                            <span className="text-inverse">{pdetail?.age}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="details-group">
                        <div className="row">
                          <div className="col-md-4">
                            <b className="text-inverse">Emergency Contact</b>
                          </div>
                          <div className="col-md-8">
                            <span className="text-inverse">
                              {pdetail?.emergency_contact_no}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="details-group">
                        <div className="row">
                          <div className="col-md-4">
                            <b className="text-inverse">Blood Group</b>
                          </div>
                          <div className="col-md-8">
                            <span className="text-inverse">
                              {pdetail?.blood_group}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="details-group">
                        <div className="row">
                          <div className="col-md-4">
                            <b className="text-inverse">Address</b>
                          </div>
                          <div className="col-md-8">
                            <span className="text-inverse">
                              {pdetail?.permenant_address_one}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="details-group">
                        <div className="row">
                          <div className="col-md-4">
                            <b className="text-inverse">ESID</b>
                          </div>
                          <div className="col-md-8">
                            <span className="text-inverse">{pesid}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="details-group">
                        <div className="row">
                          <div className="col-md-4">
                            <b className="text-inverse">Current Coach Name</b>
                          </div>
                          <div className="col-md-8">
                            <span className="text-inverse">
                              {pdetail?.current_coach_name}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="details-group">
                        <div className="row">
                          <div className="col-md-4">
                            <b className="text-inverse">
                              Past Coaches/ Mentors
                            </b>
                          </div>
                          <div className="col-md-8">
                            <span className="text-inverse">
                              {pdetail?.past_coach_or_mentor}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="details-group">
                        <div className="row">
                          <div className="col-md-4">
                            <b className="text-inverse">Kit Size</b>
                          </div>
                          <div className="col-md-8">
                            <span className="text-inverse">
                              {pdetail?.kit_size}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="details-group">
                        <div className="row">
                          <div className="col-md-4">
                            <b className="text-inverse">Shoe Size</b>
                          </div>
                          <div className="col-md-8">
                            <span className="text-inverse">
                              {pdetail?.shoe_size}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="details-group">
                        <div className="row">
                          <div className="col-md-4">
                            <b className="text-inverse">SDC Center</b>
                          </div>
                          <div className="col-md-8">
                            <span className="text-inverse">
                              {pdetail?.sdc_center}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card">
              <div className="card-header border-bottom">
                <h3 className="card-title font-weight-bold">File Uploads</h3>
              </div>
              <div className="card-body">
                <div className="border-0">
                  <div className="row tournamentitem">
                    <div className="col-md-3">
                      <div className="form-group">
                        <label className="form-label">Photograph </label>

                        <img
                          className="profile_img mb-2"
                          src={photourl}
                          height="160"
                          alt="photo"
                          onError={(e) => errorhandle(e)}
                        />
                        <input
                          type="file"
                          className="form-control"
                          accept=".jpg,.jpeg,.png"
                          onChange={photofile}
                        />
                        {photoerror !== "" && (
                          <span className="errortext">{photoerror}</span>
                        )}
                        {errorMsg !== "" && (
                          <span className="errortext">{errorMsg}</span>
                        )}
                      </div>
                    </div>
                    {hlist.length > 0 && (
                      <div className="col-md-9">
                        <h4>Highest Level Represented</h4>
                        <div className="table-responsive">
                          <table className="sp-league-table sp-data-table">
                            <thead className="sp-table-header">
                              <tr role="row">
                                <th className="text-center">Sports</th>
                                <th className="text-center">Events</th>
                                <th className="text-center">Level</th>
                              </tr>
                            </thead>
                            <tbody>
                              {hlist.map((item, j) => {
                                const getRowColor = () => {
                                  return j % 2 === 0 ? "even" : "odd";
                                };
                                return (
                                  <tr
                                    className={`sp-row-no-0 ${getRowColor()}`}
                                    role="row"
                                    key={j}
                                  >
                                    <td className="data-pct">
                                      {item.sports_type}
                                    </td>
                                    <td className="data-pct">{item.event}</td>
                                    <td className="data-pct">
                                      {item.meet_level}
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}
                  </div>

                  {filterProduct.length != 0 && (
                    <>
                      <hr />
                      <h4>Achievement List</h4>
                      <div
                        className="ag-theme-alpine ag-style"
                        style={{
                          height: filterProduct.length < 10 ? "auto" : "600px",
                        }}
                      >
                        <AgGridReact
                          columnDefs={columnPDefs}
                          rowData={filterProduct}
                          pagination="true"
                          paginationPageSize="10"
                          sortingOrder={["asc", "desc"]}
                          suppressExcelExport={true}
                          suppressDragLeaveHidesColumns={true}
                          domLayout={
                            filterProduct.length < 10 ? "autoHeight" : "normal"
                          }
                        />
                      </div>
                    </>
                  )}
                  <hr />
                  <h4>Medals vs Participation</h4>
                  <div className="col-md-4">
                    <label className="form-label">
                      Levels <span className="errortext"></span>
                    </label>
                    <select
                      className="form-control"
                      value={selectedFilter}
                      onChange={(e) => setSelectedFilter(e.target.value)}
                    >
                      <option value="">Select Level</option>
                      <option value="International">International</option>
                      <option value="National">National</option>
                      <option value="State">State</option>
                      <option value="Zonal">Zonal</option>
                      <option value="District">District</option>
                      <option value="Inter_School">Inter School</option>
                      <option value="Intra_school">Intra School</option>
                    </select>
                  </div>
                  <div id="chart-container" className="col-md-12">
                    {gdata && <Bar data={gdata} options={opts} />}
                  </div>
                  <hr />

                  {ptdet.length != 0 && (
                    <>
                      <h4>Personal Timings</h4>
                      <div
                        className="ag-theme-alpine ag-style"
                        style={{ height: ptdet.length < 10 ? "auto" : "600px" }}
                      >
                        <AgGridReact
                          columnDefs={columnPtDefs}
                          rowData={ptdet}
                          pagination="true"
                          paginationPageSize="10"
                          sortingOrder={["asc", "desc"]}
                          suppressExcelExport={true}
                          suppressDragLeaveHidesColumns={true}
                          domLayout={
                            ptdet.length < 10 ? "autoHeight" : "normal"
                          }
                        />
                      </div>

                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label className="form-label">
                              Sports <span className="errortext"> *</span>
                            </label>
                            <select
                              className="form-control custom-select"
                              value={ptsport}
                              onChange={(e) => personalsport(e, stype)}
                            >
                              <option value="" defaultValue disabled>
                                --Select Sports--
                              </option>
                              {splist.map((item, index) => {
                                return (
                                  <option
                                    key={index}
                                    value={item.sports_cat_uid}
                                  >
                                    {item.sports_category}
                                  </option>
                                );
                              })}
                            </select>
                          </div>
                        </div>
                        {sname.toUpperCase() === "ATHLETICS" && (
                          <div className="col-md-4">
                            <div className="form-group">
                              <label className="form-label">
                                Event <span className="errortext"> *</span>
                              </label>
                              <Select
                                className="dropdown"
                                placeholder="Select Event"
                                value={pevent}
                                options={pelist}
                                onChange={handleEvent}
                                isSearchable={true}
                                isClearable
                                hidden
                              />
                            </div>
                          </div>
                        )}

                        <div className="col-md-4">
                          <div className="form-group">
                            <label className="form-label">
                              Type of Event{" "}
                              <span className="errortext"> *</span>
                            </label>
                            <select
                              className="form-control custom-select"
                              value={stype}
                              onChange={(e) =>
                                loadperson(ptsport, pevent, e.target.value)
                              }
                            >
                              <option value="" defaultValue disabled>
                                --Select Type of Event--
                              </option>
                              <option value="ALL">ALL</option>
                              <option value="COMPETITION">COMPETITION</option>
                              <option value="TRAINING">TRAINING</option>
                            </select>
                          </div>
                        </div>
                        {ptdata === "" && (
                          <div className="col-md-12">
                            <h4 className="text-danger" role="alert">
                              No data availabe for the above selection
                            </h4>
                          </div>
                        )}
                        {ptdata && (
                          <div id="chart-container" className="col-md-12">
                            <Line data={ptdata} options={copts} />
                          </div>
                        )}
                      </div>
                    </>
                  )}

                  <hr />
                  <h4>Sports Assessment</h4>

                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label className="form-label">
                          Sports <span className="errortext"> *</span>
                        </label>
                        <select
                          className="form-control custom-select"
                          value={usport}
                          onChange={(e) => loadsport(e)}
                        >
                          <option value="" defaultValue disabled>
                            --Select Sports--
                          </option>
                          {splist.map((item, index) => {
                            return (
                              <option key={index} value={item.sports_cat_uid}>
                                {item.sports_category}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label className="form-label">
                          Parameter Type <span className="errortext"> *</span>
                        </label>
                        <select
                          className="form-control custom-select"
                          value={asstype}
                          onChange={(e) => loadgraph(usport, e)}
                        >
                          <option value="" defaultValue disabled>
                            --Select Parameter Type--
                          </option>
                          {tlist.map((item, index) => {
                            return (
                              <option key={index} value={item.id}>
                                {item.parameter_type}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </div>
                  </div>

                  {glist.length == 0 && (
                    <h4 className="text-danger">No Graph Data Available</h4>
                  )}
                  {glist.length !== 0 && (
                    <>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "flex-start",
                        }}
                      >
                        {/* Radar chart on the left */}
                        <div id="chart-container" style={{ flex: 1 }}>
                          <Radar data={grdata} options={ropts} />
                        </div>

                        {/* Parameter name + description on the right */}
                        <div style={{ width: "300px", marginLeft: "20px" }}>
                          <h4>Parameter Descriptions</h4>
                          <ul style={{ listStyle: "none", padding: 0 }}>
                            {paramList
                              .filter(
                                (param) =>
                                  param.desc && param.desc.trim() !== ""
                              ) // Only include if desc is non-empty
                              .map((param, index) => (
                                <li
                                  key={index}
                                  style={{ marginBottom: "10px" }}
                                >
                                  <strong>{param.name}</strong> -{" "}
                                  <span style={{ color: "#555" }}>
                                    {param.desc}
                                  </span>
                                </li>
                              ))}
                          </ul>
                        </div>
                      </div>
                    </>
                  )}

                  {attdet.length != 0 && (
                    <>
                      <hr />
                      <h4>Attendance Record</h4>
                      <div className="row mb-2">
                        <div className="col-md-4">
                          <label className="form-label">Financial Year</label>

                          <select
                            className="form-control"
                            value={tyear}
                            onChange={(e) => viewlist(e.target.value)}
                          >
                            {/* <option value={0}>All</option> */}
                            <option value={currentYear}>Current Year</option>
                            <option value={lastYear}>Last Year</option>
                          </select>
                        </div>
                      </div>
                      {localStorage.getItem("Role") == "1" &&
                        localStorage.getItem("Subrole") == "1" && (
                          <>
                            <div
                              className="ag-theme-alpine ag-style"
                              style={{
                                height: attdet.length < 10 ? "auto" : "600px",
                              }}
                            >
                              <AgGridReact
                                columnDefs={columnAtDefs}
                                rowData={attdet}
                                pagination="true"
                                paginationPageSize="10"
                                sortingOrder={["asc", "desc"]}
                                suppressExcelExport={true}
                                suppressDragLeaveHidesColumns={true}
                                domLayout={
                                  attdet.length < 10 ? "autoHeight" : "normal"
                                }
                              />
                            </div>
                          </>
                        )}

                      {gattdet && (
                        <div id="chart-container">
                          {gattdet && gattdet.labels && gattdet.datasets && (
                            <Bar data={gattdet} options={aopts} />
                          )}
                        </div>
                      )}
                    </>
                  )}
                  {phdet.length != 0 && (
                    <>
                      <hr />
                      <h4>Physical and Health Data</h4>
                      <div
                        className="ag-theme-alpine ag-style"
                        style={{ height: phdet.length < 10 ? "auto" : "600px" }}
                      >
                        <AgGridReact
                          columnDefs={columnPhDefs}
                          rowData={phdet}
                          pagination="true"
                          paginationPageSize="10"
                          sortingOrder={["asc", "desc"]}
                          suppressExcelExport={true}
                          suppressDragLeaveHidesColumns={true}
                          domLayout={
                            phdet.length < 10 ? "autoHeight" : "normal"
                          }
                        />
                      </div>
                    </>
                  )}
                  {phdet.length != 0 && (
                    <>
                      <hr />
                      <h4>Psychological & Behavioral Profile</h4>

                      <div className="table-responsive">
                        <table className="sp-league-table sp-data-table">
                          <thead className="sp-table-header">
                            <tr role="row">
                              <th className="text-center">
                                Personality Traits
                              </th>
                              <th className="text-center">
                                Goals - Short Term
                              </th>
                              <th className="text-center">Goals - Long Term</th>
                              <th className="text-center">
                                Role Models / Inspirations
                              </th>
                              {/* <th className="text-center">
                              Sports Psychology Assessments
                            </th> */}
                            </tr>
                          </thead>
                          <tbody>
                            {pbdet.length > 0 ? (
                              pbdet.map((item, j) => {
                                const getRowColor = () => {
                                  return j % 2 === 0 ? "even" : "odd";
                                };
                                return (
                                  <>
                                    <tr
                                      className={`sp-row-no-0 ${getRowColor()}`}
                                      role="row"
                                      key={j}
                                    >
                                      <td className="data-pct">
                                        {item.personality_traits}
                                      </td>
                                      <td className="data-pct">
                                        {item.goals_short_term}
                                      </td>
                                      <td className="data-pct">
                                        {item.goals_long_term}
                                      </td>
                                      <td className="data-pct">
                                        {item.role_model}
                                      </td>
                                    </tr>
                                  </>
                                );
                              })
                            ) : (
                              <tr>
                                <td colSpan="6" className="text-center">
                                  No data available
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </>
                  )}

                  {aclist.length > 0 && (
                  <>
                    <hr />

                    <div className="row">
                      <div className="col-md-10">
                        <h4>Athlete Contract</h4>
                      </div>
                      <div className="col-md-2">
                       
                      </div>
                      {aclist && aclist.length == 0 && (
                        <div className="col-md-12">
                          <h4 className="text-danger">
                            No Athlete Contract Uploaded
                          </h4>
                        </div>
                      )}
                      {currentRecords.map((item, index) => {
                        return (
                          <div className="col-md-2" key={index}>
                            
                            <div
                              className="form-group"
                              onClick={() => udetshow(item)}
                            >
                              {item.file_type !== "PDF" && (
                                <img
                                  className="profile_img mb-2"
                                  src={upath + item.filename_or_url}
                                  height="160"
                                  width="160"
                                  alt="Athlete Contract"
                                  onError={(e) => errorhandle(e)}
                                />
                              )}
                              {item.file_type === "PDF" && (
                                <img
                                  className="profile_img mb-2"
                                  src={require("../../../assets/images/pdf.png")}
                                  height="160"
                                  width="160"
                                  alt="Athlete Contract"
                                />
                              )}
                            </div>
                          </div>
                        );
                      })}

                      {totalRecordsToShow < aclist.length && (
                        <div className="form-group text-center mt-2">
                          <a onClick={loadMore} className="btn btn-secondary">
                            Load More
                          </a>
                        </div>
                      )}
                    </div>
                  </>
                )}
                {clist.length > 0 && (
                  <>
                    <hr />

                    <div className="row">
                      <div className="col-md-10">
                        <h4>Certificates</h4>
                      </div>
                      <div className="col-md-2">
                       
                      </div>
                      {clist.length == 0 && (
                        <div className="col-md-12">
                          <h4 className="text-danger">
                            No Certificates Uploaded
                          </h4>
                        </div>
                      )}
                      {certcurrentRecords.map((item, index) => {
                        return (
                          <div className="col-md-2" key={index}>
                           
                            <div
                              className="form-group"
                              onClick={() => udetshow(item)}
                            >
                              {item.file_type !== "PDF" && (
                                <img
                                  className="profile_img mb-2"
                                  src={upath + item.filename_or_url}
                                  height="160"
                                  width="160"
                                  alt="Certificates"
                                  onError={(e) => errorhandle(e)}
                                />
                              )}
                              {item.file_type === "PDF" && (
                                <img
                                  className="profile_img mb-2"
                                  src={require("../../../assets/images/pdf.png")}
                                  height="160"
                                  width="160"
                                  alt="Certificates"
                                />
                              )}
                            </div>
                          </div>
                        );
                      })}

                      {certRecordsToShow < clist.length && (
                        <div className="form-group text-center mt-2">
                          <a
                            onClick={certloadMore}
                            className="btn btn-secondary"
                          >
                            Load More
                          </a>
                        </div>
                      )}
                    </div>
                  </>
                )}
                {mclist.length > 0 && (
                  <>
                    <hr />

                    <div className="row">
                      <div className="col-md-10">
                        <h4>Media Coverage</h4>
                      </div>
                      <div className="col-md-2">
                       
                      </div>
                      {mclist.length == 0 && (
                        <div className="col-md-12">
                          <h4 className="text-danger">
                            No Media Coverage Uploaded
                          </h4>
                        </div>
                      )}
                      {mediacurrentRecords.map((item, index) => {
                        return (
                          <div className="col-md-2" key={index}>
                           
                            <div
                              className="form-group"
                              onClick={() => udetshow(item)}
                            >
                              {item.file_type !== "PDF" && (
                                <img
                                  className="profile_img mb-2"
                                  src={upath + item.filename_or_url}
                                  height="160"
                                  width="160"
                                  alt="Media coverage"
                                  onError={(e) => errorhandle(e)}
                                />
                              )}
                              {item.file_type === "PDF" && (
                                <img
                                  className="profile_img mb-2"
                                  src={require("../../../assets/images/pdf.png")}
                                  height="160"
                                  width="160"
                                  alt="Media coverage"
                                />
                              )}
                            </div>
                          </div>
                        );
                      })}
                      {mediaRecordsToShow < mclist.length && (
                        <div className="form-group text-center mt-2">
                          <a
                            onClick={medialoadMore}
                            className="btn btn-secondary"
                          >
                            Load More
                          </a>
                        </div>
                      )}
                    </div>
                  </>
                )}
                {plist.length > 0 && (
                  <>
                    <hr />
                    <div className="row">
                      <div className="col-md-10">
                        <h4>Photos</h4>
                      </div>
                      <div className="col-md-2">
                       
                      </div>
                      {plist.length == 0 && (
                        <div className="col-md-12">
                          <h4 className="text-danger">No Photos Uploaded</h4>
                        </div>
                      )}
                      {photocurrentRecords.map((item, index) => {
                        return (
                          <div className="col-md-2" key={index}>
                           
                            <div
                              className="form-group"
                              onClick={() => udetshow(item)}
                            >
                              {item.file_type !== "PDF" && (
                                <img
                                  className="profile_img mb-2"
                                  src={upath + item.filename_or_url}
                                  height="160"
                                  width="160"
                                  alt="Photos"
                                  onError={(e) => errorhandle(e)}
                                />
                              )}
                              {item.file_type === "PDF" && (
                                <img
                                  className="profile_img mb-2"
                                  src={require("../../../assets/images/pdf.png")}
                                  height="160"
                                  width="160"
                                  alt="Photos"
                                />
                              )}
                            </div>
                          </div>
                        );
                      })}

                      {photoRecordsToShow < plist.length && (
                        <div className="form-group text-center mt-2">
                          <a
                            onClick={photoloadMore}
                            className="btn btn-secondary"
                          >
                            Load More
                          </a>
                        </div>
                      )}
                    </div>
                  </>
                )}
                {vlist.length > 0 && (
                  <>
                    <hr />
                    <div className="row">
                      <div className="col-md-10">
                        <h4>Videos</h4>
                      </div>
                      <div className="col-md-2">
                       
                      </div>
                      {vlist.length == 0 && (
                        <div className="col-md-12">
                          <h4 className="text-danger">No Videos Uploaded</h4>
                        </div>
                      )}
                      {videocurrentRecords.map((item, index) => {
                        return (
                          <div className="col-md-2" key={index}>
                           
                            <div
                              className="form-group"
                              onClick={() => udetshow(item)}
                            >
                              <img
                                className="profile_img mb-2"
                                src={require("../../../assets/images/video.png")}
                                height="160"
                                width="160"
                                alt="Videos"
                              />
                            </div>
                          </div>
                        );
                      })}
                      {videoRecordsToShow < vlist.length && (
                        <div className="form-group text-center mt-2">
                          <a
                            onClick={videoloadMore}
                            className="btn btn-secondary"
                          >
                            Load More
                          </a>
                        </div>
                      )}
                    </div>
                  </>
                )}
                {oflist.length > 0 && (
                  <>
                    <hr />
                    <div className="row">
                      <div className="col-md-10">
                        <h4>Other Files</h4>
                      </div>
                      <div className="col-md-2">
                       
                      </div>
                      {oflist.length == 0 && (
                        <div className="col-md-12">
                          <h4 className="text-danger">
                            No Other Files Uploaded
                          </h4>
                        </div>
                      )}
                      {othercurrentRecords.map((item, index) => {
                        return (
                          <div className="col-md-2" key={index}>
                            
                            <div
                              className="form-group"
                              onClick={() => udetshow(item)}
                            >
                              {item.file_type !== "PDF" && (
                                <img
                                  className="profile_img mb-2"
                                  src={upath + item.filename_or_url}
                                  height="160"
                                  width="160"
                                  alt="Athlete Contract"
                                  onError={(e) => errorhandle(e)}
                                />
                              )}
                              {item.file_type === "PDF" && (
                                <img
                                  className="profile_img mb-2"
                                  src={require("../../../assets/images/pdf.png")}
                                  height="160"
                                  width="160"
                                  alt="Athlete Contract"
                                />
                              )}
                            </div>
                          </div>
                        );
                      })}

                      {otherRecordsToShow < oflist.length && (
                        <div className="form-group text-center mt-2">
                          <a
                            onClick={otherloadMore}
                            className="btn btn-secondary"
                          >
                            Load More
                          </a>
                        </div>
                      )}
                    </div>
                  </>
                )}
                </div>
              </div>
            </div>

            <Modal show={ushow} size="xl" onHide={udetclose}>
              <Modal.Header>
                <h4> {udetail.file_upload_type}</h4>
              </Modal.Header>
              <Modal.Body>
                <Row className="row-sm mx-0">
                  <Col lg={12} md={12}>
                    <div className="form-group">
                      {udetail.file_type === "URL" && (
                        <iframe
                          width="100%"
                          height="300"
                          src={udetail.filename_or_url}
                          frameBorder="0"
                          allowFullScreen
                          title="Embedded youtube"
                        />
                      )}

                      {udetail.file_type === "Video" && (
                        <video controls width="100%" height="300">
                          <source
                            src={upath + udetail.filename_or_url}
                            type="video/mp4"
                          />
                        </video>
                      )}

                      {udetail.file_type === "PDF" && (
                        <iframe
                          width="100%"
                          height="400"
                          src={upath + udetail.filename_or_url}
                          allowFullScreen
                        />
                      )}

                      {udetail.file_type === "Image" && (
                        <img
                          src={upath + udetail.filename_or_url}
                          alt="Photo"
                          width="100%"
                        />
                      )}
                    </div>
                  </Col>
                </Row>
              </Modal.Body>
              <Modal.Footer>
                <a
                  className="btn btn-success me-2"
                  href={upath + udetail.filename_or_url}
                  download={upath + udetail.filename_or_url}
                  target="_blank"
                >
                  Download
                </a>
                <a className="btn btn-danger" onClick={udetclose}>
                  Close
                </a>
              </Modal.Footer>
            </Modal>

            <div className="text-right">
              <button
                type="submit"
                className="btn btn-primary me-2"
                onClick={perflist}
              >
                Overall Performance
              </button>

              <button
                type="submit"
                className="btn btn-secondary me-2"
                onClick={perftourlist}
              >
                Tournament Wise Performance
              </button>

              <button
                type="submit"
                className="btn btn-success"
                onClick={subbmitprofile}
              >
                Update Profile
              </button>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};
